export default __webpack_public_path__ + "static/media/datetime.fcafc85c.svg";